export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-32 border-t border-border/70 bg-background">
      <div className="container-editorial py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="font-display text-2xl">SlipShare</div>
          <p className="mt-3 text-sm text-muted-foreground max-w-xs">
            The private marketplace for boat & jet ski slips. Lake, river, bay, or coast — daily, weekly, monthly, or yearly.
          </p>
          <div
            data-testid="veteran-badge-footer"
            className="mt-5 inline-flex items-center gap-2 rounded-full border border-accent/30 bg-accent/5 px-3 py-1.5 text-[11px] uppercase tracking-[0.15em] text-accent"
          >
            <span aria-hidden="true">★</span>
            <span>Veteran-Owned · Service-Disabled</span>
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-muted-foreground mb-3">Explore</div>
          <ul className="space-y-2 text-sm">
            <li>Browse Docks</li><li>List Your Dock</li><li>How it Works</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-muted-foreground mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li>About</li><li>Trust & Safety</li><li>Contact</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-muted-foreground mb-3">Legal</div>
          <ul className="space-y-2 text-sm"><li>Terms</li><li>Privacy</li></ul>
        </div>
      </div>
      <div className="border-t border-border/70 py-5 text-xs text-muted-foreground container-editorial flex justify-between">
        <span>&copy; {new Date().getFullYear()} SlipShare, Inc. — Founded by a U.S. Army veteran.</span>
        <span>Made for people who love the water.</span>
      </div>
    </footer>
  );
}
